<template>
	<div class="row">
		<div class="col-12">
			<div class="card mb-2 homeBg">
				<div class="d-flex align-items-center p-3">
					<div class="align-items-center justify-content-center me-2">
						<img :src="tema == 'dark' ? require('@/assets/images/sigap-logo-branco.png') : require('@/assets/images/sigap-logo.png')" alt="Mooli Logo" class="m-2 me-4" width="190">
					</div>
					<!-- <h2 class="font-30 mt-0 mb-0">aaa<span class="d-none d-md-inline"><small class="mx-2"><i class="fas fa-horizontal-rule font-17"></i></small>aaaa</span></h2> -->
				</div>
			</div>
		</div>
		<div class="col-12">
			<div class="cards-1 atalhos">
				<router-link to="/usuarios" id="geral_step5" class="card iconBg" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Usuários')">
					<div class="card-body p-2 text-center">
						<!-- <img class="mb-2" src="@/assets/images/icons_home/iconeUsuarios.png" height="75" width="75" alt="Icon"> -->
						<lord-icon
							src="https://cdn.lordicon.com/ddumgjyf.json"
							trigger="in"
							delay="100"
							:colors="tema == 'dark' ? 'primary:#ffffff' : 'primary:#000000'"
							style="width:100px;height:100px">
						</lord-icon>
						<h6 class="font-14">Usuários</h6>
					</div>
				</router-link>
				<router-link to="/entidades" id="geral_step6" class="card" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Entidades')" data-intro="O sistema requer que existam entidades cadastradas." data-step="2">
					<div class="card-body p-2 text-center">
						<!-- <img class="mb-2" src="@/assets/images/icons_home/iconeEntidades.png" height="75" width="75" alt="Icon"> -->
						<lord-icon
							src="https://cdn.lordicon.com/csjdsxip.json"
							trigger="in"
							delay="600"
							:colors="tema == 'dark' ? 'primary:#ffffff' : 'primary:#000000'"
							style="width:100px;height:100px">
						</lord-icon>
						<h6 class="font-14">Entidades</h6>
					</div>
				</router-link>
				<router-link to="/sentenciados" id="geral_step7" class="card" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Sentenciados')" data-intro="Com tudo pronto, o próximo passo é cadastrar os sentenciados." data-step="3">
					<div class="card-body p-2 text-center">
						<!-- <img class="mb-2" src="@/assets/images/icons_home/iconeApenados.png" height="75" width="75" alt="Icon"> -->
						<lord-icon
							src="https://cdn.lordicon.com/wcfzixwo.json"
							trigger="in"
							delay="1100"
							:colors="tema == 'dark' ? 'primary:#ffffff' : 'primary:#000000'"
							style="width:100px;height:100px">
						</lord-icon>
						<h6 class="font-14">Sentenciados</h6>
					</div>
				</router-link>
				<router-link to="/arquivos" id="geral_step8" class="card" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Arquivos')" data-intro="Com tudo pronto, o próximo passo é cadastrar os arquivos." data-step="4">
					<div class="card-body p-2 text-center">
						<!-- <img class="mb-2" src="@/assets/images/icons_home/iconeApenados.png" height="75" width="75" alt="Icon"> -->
						<lord-icon
							src="https://cdn.lordicon.com/mokrevih.json"
							trigger="in"
							delay="1600"
							:colors="tema == 'dark' ? 'primary:#ffffff' : 'primary:#000000'"
							style="width:100px;height:100px">
						</lord-icon>
						<h6 class="font-14">Arquivos</h6>
					</div>
				</router-link>

				<a href="javascript:;" class="card cursor-auto" v-if="!dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Usuários') && !dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Sentenciados')
					&& !dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Processos') && !dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Entidades')
					&& !dadosUsuario.usuarioPermissoes.includes('Ver Alertas') && !dadosUsuario.usuarioEntidade">
					<div class="card-body p-2 text-center">
						<img class="mb-2" src="@/assets/images/icons_home/iconeCadeado.png" height="75" width="75" alt="Icon">
						<h6 class="font-13">Sem Permissão</h6>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Página_Inicial',
	computed: {
		... mapState({
			tokenSessao: state => state.tokenSessao,
			dadosUsuario: state => state.dadosUsuario,
			tema: state => state.tema,
		})
	},
	mounted() {
		let ref = this;

		this.$axios.interceptors.request.use(function(config) {
			if (ref.tokenSessao != null && ref.dadosUsuario != null) {
				config.headers.Authorization = 'Bearer '+ ref.tokenSessao +'@@@'+ ref.dadosUsuario.usuarioUsername;
			}

			return config;
		});
	}
}

</script>

<style scoped>

.row {
	margin: 0;
}

.row>div {
	padding: 0;
}

.card {
	margin-bottom: 0;
}

h6 {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.cards {
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
   gap: 0.5rem;
   padding: 0;
   list-style-type: none;
}

.atalhos .card:hover {
	background-color: var(--hover-bg);
}

</style>